export const timeMixin = {
    methods: {
        /**
         * Returns UTC time as formatted local time
         * @param dateStr UTC time
         * @returns {DateTimeFormatResult|VueI18n.DateTimeFormatResult|string}
         */
        getUtcToLocalDateString: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(this.setTime(dateStr)), 'long')
            }
            return ''
        },

        /**
         * Returns UTC time as formatted local time
         * @param dateStr UTC time
         * @returns {DateTimeFormatResult|VueI18n.DateTimeFormatResult|string}
         */
        getUtcToLocalShortDateString: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(this.setTime(dateStr)), 'shortDate')
            }
            return ''
        },

        /**
         * Returns time as formatted time
         * @param dateStr time in any timezone
         * @returns {DateTimeFormatResult|VueI18n.DateTimeFormatResult|string}
         */
        getDateString: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(dateStr), 'long')
            }
            return ''
        },

        /**
         * Returns time as formatted time
         * @param dateStr time in any timezone
         * @returns {DateTimeFormatResult|VueI18n.DateTimeFormatResult|string}
         */
        getShortDateString: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(dateStr), 'shortDate')
            }
            return ''
        },

        setTime: function (timeStr) {
            if (timeStr.indexOf('+') < 0) {
                timeStr += '+00:00'
            }
            return timeStr
        },

        toShortDateStr: function (dateStr) {
            let d = new Date(this.setTime(dateStr));
            return this.getAsShortDateString(d)
        },

        getToday: function () {
            let d = new Date();
            d.setDate(d.getDate())
            return this.getAsShortDateString(d)
        },

        getNextMonth: function () {
            let d = new Date();
            d.setMonth(d.getMonth() + 1)
            return this.getAsShortDateString(d)
        },

        getAsShortDateString: function (date) {
            let month = date.getMonth() + 1
            if (month < 10)  {
                month = '0' + month;
            }
            let day = date.getDate()
            if (day < 10) {
                day = '0' + day;
            }
            return date.getFullYear() + '-'  + month + '-' + day
        },

        addEndOfDay: function (dateStr) {
            return dateStr + 'T23:59'
        },

        isDatePassed(dateStr) {
            let now = new Date();
            let then = new Date(this.setTime(dateStr))
            return now.getTime() > then
        }

    }
}
